import React from 'react';
import { withStyles, Button } from '@material-ui/core';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import clsx from 'clsx';
import './Button.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = theme => ({
    button: {
        fontSize: '16px',
        fontWeight: '400',
        fontFamily: 'SF Pro Display',
        backgroundColor: '#36f',
        color: 'white',
        textTransform: 'inherit',
        padding: '6px 16px',
        borderRadius: '4px',
        textAlign: 'left',
        minWidth: '32px',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: '#2952cc'
        },
        '& svg': {
            maxWidth: '20px'
        },
        // '& span': {
        //     paddingLeft: 6
        // },
        '&.primary': {
            boxShadow: '0px 4px 8px ' + theme.colors.primary[500] + '40',
            backgroundColor: '#36f',
            color: theme.buttons.primary.default.text,
            border: '1px solid  #36f',
            '& svg': {
                '& path': {
                    'fill': 'white'
                }
            },
            '&:hover': {
                backgroundColor: '#2952cc',
                color: theme.buttons.primary.hover.text,
                border: '1px solid ' + theme.buttons.primary.hover.border,
                '& svg': {
                    '& path': {
                        'fill': 'white'
                    }
                },
            },
            '&:active': {
                backgroundColor: theme.buttons.primary.active.background,
                color: theme.buttons.primary.active.text,
                border: '1px solid ' + theme.buttons.primary.active.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.active.svg
                    }
                },
            },
            '&:disabled': {
                backgroundColor: theme.buttons.primary.disabled.background,
                color: theme.buttons.primary.disabled.text,
                border: '1px solid ' + theme.buttons.primary.disabled.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.disabled.svg
                    }
                },
            },

        },
        '&.secondary': {
            backgroundColor: theme.buttons.secondary.default.background,
            color: theme.buttons.secondary.default.text,
            border: '1px solid ' + theme.buttons.secondary.default.border,
            '& svg': {
                '& path': {
                    'fill': theme.buttons.secondary.default.svg
                }
            },
            '&:hover': {
                backgroundColor: theme.buttons.secondary.hover.background,
                color: theme.buttons.secondary.hover.text,
                border: '1px solid ' + theme.buttons.secondary.hover.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.hover.svg
                    }
                },
            },
            '&:active': {
                backgroundColor: theme.buttons.secondary.active.background,
                color: theme.buttons.secondary.active.text,
                border: '1px solid ' + theme.buttons.secondary.active.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.active.svg
                    }
                },
            },
            '&:disabled': {
                backgroundColor: theme.buttons.secondary.disabled.background,
                color: theme.buttons.secondary.disabled.text,
                border: '1px solid ' + theme.buttons.secondary.disabled.border,
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.disabled.svg
                    }
                },
            }
        },
        '&.tertiary': {
            border: '1px solid ' + theme.buttons.tertiary.default.border,
            '&:hover': {
                border: '1px solid ' + theme.buttons.tertiary.hover.border,
            },
            '&:active': {
                border: '1px solid ' + theme.buttons.tertiary.active.border,
            },
            '&:disabled': {
                border: '1px solid ' + theme.buttons.tertiary.disabled.border,
            }
        },
        '&.small': {
            fontSize: '12px',
            height: '32px',
            lineHeight: '32px'
        },
        '&.medium': {
            fontSize: '14px',
            height: '41px',
            lineHeight: '41px'
        },
        '&.large': {
            fontSize: '14px',
            height: '48px',
            lineHeight: '48px',
            padding: '0 24px'
        },
        '&.full': {
            fontSize: '14px',
            height: '48px',
            lineHeight: '48px',
            padding: '0 24px',
            width: '100%'
        },
    }
});

const CustomButton = (props) => {
    const { classes, onClick, size, color, className, children, tooltip, icon = undefined, ...other } = props;
    let button =
        <Button
            onClick={onClick}
            className={clsx(classes.button, size, color, className, icon && 'button-icon')}
            {...other}
        >
            {icon && <FontAwesomeIcon icon={icon} />}
            {children}
        </Button>

    return (
        tooltip !== undefined ?
            <CustomToolTip
                titletext={tooltip}
                jsx={
                    button
                }
            /> : button

    )
}
export default withStyles(styles)(CustomButton);